// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Link } from "@reach/router";
import { RouteComponentProps } from "@reach/router";
import { Button, Layout, Divider } from "antd";
import PageHeader from "../../components/PageHeader";
import PageBody from "../../components/PageBody";
import PageTitle from "../../components/PageTitle";
import { useTranslation } from "react-i18next";
import configuration from "../../../utils/Config";

const AuthError: React.FunctionComponent<RouteComponentProps> = () => {
  const { t } = useTranslation();
  return (
    <>
      <Layout style={{ height: "100vh" }} className="content-container">
        <Layout.Content className="content">
          <PageHeader>
            <PageTitle title={t("dashboard.title")} />
          </PageHeader>

          <PageBody>
            <div className="text-center">{t("auth.failed")}</div>
            <Divider />
            <div className="text-center">
              <Button type="default" className="btn-secondary">
                <Link
                  to="#"
                  onClick={() => {
                    window.location.href = configuration.frontendBaseUrl + "/";
                  }}
                >
                  {t("auth.loginAgain")}
                </Link>
              </Button>
            </div>
          </PageBody>
        </Layout.Content>
      </Layout>
    </>
  );
};

export default AuthError;
